var render, staticRenderFns
import script from "./WindowComponent.vue?vue&type=script&lang=js"
export * from "./WindowComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e659204",
  null
  
)

export default component.exports